import Image from 'next/image';

type ImageType = {
  url: string;
  alt: string;
  title: string;
};
interface IPill {
  index: number;
  name: string;
  image?: ImageType;
  isActive: boolean;
}

export const Pill: React.FC<IPill> = ({ index, name, image, isActive }) => {
  const basePadding = 'px-3 py-[2px] lg:px-4 lg:py-1.5';
  const imagePadding = 'px-1 py-1 lg:px-2 lg:py-1.5 lg:w-[44px] lg:h-[44px]';
  return (
    <div
      className={`flex cursor-pointer items-center justify-center rounded-full border text-sm lg:text-xl ${
        image && index === 0 ? imagePadding : basePadding
      } ${
        isActive
          ? ' border-black bg-black text-white'
          : 'border-grey bg-white text-black'
      }`}
    >
      {image && index === 0 ? (
        <>
          <Image
            className={`lg:hidden ${isActive ? 'invert' : ''}`}
            src={image.url}
            alt={image.alt}
            width={17}
            height={17}
          />
          <Image
            className={`hidden lg:block ${isActive ? 'invert' : ''}`}
            src={image.url}
            alt={image.alt}
            width={24}
            height={24}
          />
        </>
      ) : (
        <span>{name}</span>
      )}
    </div>
  );
};
